import axios from 'axios';

const postToSubscribeToNewsletter = async (errorHandler, locale, body) => {
    const newsletterEndpointv3 = `/subscribe/api/register/`;
    const headers = {
        Accept: 'application/json',
        'Accept-Language': locale,
        'Content-Type': 'application/json',
        'x-caller': 'uxt-shop-footer',
    };
    try {
        const response = axios.post(newsletterEndpointv3, body, { headers });
        return response;
    }
    catch (error) {
        errorHandler.captureException(error);
        throw error;
    }
};

export { postToSubscribeToNewsletter };
//# sourceMappingURL=newsletterSubscriptionService.js.map
